/*
 * Copyright (C) 2013 Minted Inc.
 *
 * All Rights Reserved
 *
 * CTAG:COMMUNITY:CHALLENGES
 */

/*
  UMD header generated via modularize.js at 2015-03-13T23:53:07.280Z
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/underscore-1.8.2.min': '_'
})(this, function (m_module, Backbone, _) {

var M = m_module.M;

"use strict";

  M.Model = M.Model || {};
  M.Model.Design = M.Model.Design || {};

  /**
   * @class M.Model.Design.Poll
   * A 'poll' of 4 design options that takes the place of a design version.  A
   * given design can have 0 or more polls, and only one poll is running at any
   * given time.
   *
   * A new poll will be automatically give 4 blank options, which will manage
   * the ui for creating new options. The poll and options are all sent in a
   * single request to create the poll, and all get created at once.
   */
  M.Model.Design.Poll = Backbone.Model.extend({
    defaults: {
      id: null,
      design: null,
      options: new M.Collection.Design.PollOption(),
    },

    url: function () {
      var url = Backbone.Model.prototype.url.call(this);
      // If this.versionOption exists, append it to the url so that when we
      // the backend will know how the poll is to be ended.
      if (this.versionOption) {
        url += '/' + encodeURIComponent(this.versionOption);
      }
      return url;
    },

    initialize: function() {
      this.urlRoot = this.get('urlPaths')['designPollCreateUrlName'];
      if (this.isNew()) {
        // Get 4 blank options to render into the create poll UI
        this.get('options').add(_.map({length: 4}, function() {
          return new M.Model.Design.PollOption({
            poll: this
          });
        }));
      }

      this.bind('change', _.bind(this.optionsToCollection, this));
    },

    optionsToCollection: function() {
      var options = this.get('options');
      if (options &&
          !(options instanceof M.Collection.Design.PollOption)) {
        this.set({
          options: new M.Collection.Design.PollOption(options)
        });
      }
    },

    toJSON: function() {
      var options = this.get('options');
      if (options) {
        options = options.toJSON && options.toJSON();
        options = _.filter(options, _.identity);
      }
      return {
        id: this.id,
        options: options,
        design: this.get('design')
      };
    },

    /**
     * Ends the poll.
     *
     * @param versionOption {String} Possible values are 'current_version'
     * or an option id.
     * @param options {Object} Options to be forwarded to this.destroy call.
     */
    end: function (versionOption, options) {
      // Persist version option onto this so that this.url can properly
      // build the request url to end the poll.
      this.versionOption = versionOption;
      return this.destroy(options);
    }
  });

return {
};

});
